import SuperTokens from 'supertokens-auth-react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { getSuperTokensRoutesForReactRouterDom } from 'supertokens-auth-react/ui';
import * as reactRouterDom from 'react-router-dom';
import { PasswordlessPreBuiltUI } from 'supertokens-auth-react/recipe/passwordless/prebuiltui';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './state';
import { initializeSentry, superTokensConfig } from './config';
import { ThemeProvider } from './components';
import { AuthPage, ProtectedRoutes, Layout, Home, SkillsAndCompetences, SkillFrameworkDetails, CalendarPage, ActivePlan, ManageOrganization, BoardsManagement, ManageUsers, SkillsAndCompetencesGenerate, ShowProjectDetails, Projects, NotificationsPage } from './pages';
import { PublicTenantRoutes, TenantDashboardRoute } from './guards';
import {
  Profile,
  Wizard,
  PublicSkills,
  PublicPlans,
  PublicClients,
  PublicCareers,
  PublicCareerDetails,
  PublicClientOrganizationDetails,
  PublicClientProjectDetails,
  CareerOverview,
} from './constants';
import Courses from './pages/courses';
import CourseDetailPage from './pages/courses/course-detail';
import AddAssignmentPage from './pages/courses/add-assignment';
import GenerateCoursePage from './pages/courses/generate-course';

SuperTokens.init(superTokensConfig());
initializeSentry();

export default function App() {
  return (
    <ThemeProvider defaultTheme="light">
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <BrowserRouter>
            <Routes>
              {/* Auth routes */}
              <Route element={<AuthPage />}>
                {getSuperTokensRoutesForReactRouterDom(reactRouterDom, [
                  PasswordlessPreBuiltUI,
                ])}
              </Route>
              <Route element={<ProtectedRoutes />}>
                <Route element={<Layout />}>
                  <Route path="/organization/register" element={<Wizard />} />
                  <Route path="/" element={<Home />} />

                  {/* Tenant routes (WITH sidebar) */}
                  <Route path="/:tenant">
                    <Route path="jobs" element={<PublicCareers />} />
                    <Route path="jobs/:careerId" element={<PublicCareerDetails />} />
                    <Route path="career-overview" element={<CareerOverview />} />
                    <Route path="dashboard" element={<TenantDashboardRoute />} />
                    <Route element={<PublicTenantRoutes />}>
                      <Route path="skills" element={<PublicSkills />} />
                      <Route path="plans" element={<PublicPlans />} />
                      <Route path="clients" element={<PublicClients />} />
                      <Route
                        path="clients/organization_details/:organizationId"
                        element={<PublicClientOrganizationDetails />}
                      />
                      <Route
                        path="clients/organization_details/:organizationId/projects/:projectId"
                        element={<PublicClientProjectDetails />}
                      />
                    </Route>
                    <Route path="profile" element={<Profile />} />
                    <Route path="notifications" element={<NotificationsPage />} />
                    <Route path="projects">
                      <Route index element={<Projects />} />
                      <Route
                        path=":projectId"
                        element={<ShowProjectDetails />}
                      />
                    </Route>
                    <Route path="projects" element={<Projects />} />
                    <Route path="courses" element={<Courses />} />

                    <Route
                      path="courses/:courseId"
                      element={<CourseDetailPage />}
                    />

                    <Route path="courses/:courseId" element={<CourseDetailPage />} />
                    <Route path="courses/:courseId/add-assignment" element={<AddAssignmentPage />} />
                    <Route path="courses/generate" element={<GenerateCoursePage />} />
                    <Route path="calendar" element={<CalendarPage />} />
                    <Route
                      path="admin-tools/skills-and-competences"
                      element={<SkillsAndCompetences />}
                    />
                    <Route
                      path="admin-tools/skills-and-competences/generate"
                      element={<SkillsAndCompetencesGenerate />}
                    />
                    <Route
                      path="admin-tools/skills-and-competences/:id"
                      element={<SkillFrameworkDetails />}
                    />
                    <Route
                      path="admin-tools/active-plan"
                      element={<ActivePlan />}
                    />
                    <Route
                      path="admin-tools/manage-organization"
                      element={<ManageOrganization />}
                    />
                    <Route
                      path="admin-tools/boards/*"
                      element={<BoardsManagement />}
                    />
                    <Route path="my-boards/*" element={<BoardsManagement />} />
                    <Route
                      path="admin-tools/manage-users"
                      element={<ManageUsers />}
                    />
                  </Route>

                  {/* Not found */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
              </Route>
              <Route path="*" element={<Navigate to="/auth" replace />} />
            </Routes>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  );
}
